(function ($) {

    // setup shadowbox (outside page load to prevent autoplay)
    Shadowbox.init({
        skipSetup: true,
        animate: false,
        animateFade: false,
        players: ['iframe', 'html']
    });

    // Helper function for autocomplete
    var setFields = function (json) {
        $.each(json, function (name, value) {
            name = name.charAt(0).toUpperCase() + name.slice(1);
            $("form input[name='" + name + "'], select[name='" + name + "']").val(value);
            $(".logic-prefilled-address ." + name).text(value);
        });
    }

    $(function () {

        var countryCanBeAccepted = false;
        var selectedCountryCode = $("input[name='CountryCode']").val();
        var selectedCountryFullName = $("#" + selectedCountryCode + "-flag").data("country-name");

        // sets up smaller window for page load / window resize events
        function handleSmallWindowSize() {
            $('#listingContent > div').each(function (e) {
                var hasChildren = $(this).find('div.sectionContent').children().length > 0;
                if (hasChildren)
                    $(this).removeClass('displayAway');
                if ($(this).find('a').hasClass('selected'))
                    $(this).find('div.sectionContent').show();
                else
                    $(this).find('div.sectionContent').hide();
            });
        }

        // sets up larger window for page load / window resize events
        function handleLargeWindowSize() {

            // ensure additional content divs are not hidden (as a result of jQuery slideUp) before adding class 'displayAway'
            $('#listingContent .sectionContent').show();
            $('#listingContent > div').addClass('displayAway');
            $('ul#sectionTabs li').removeClass('selected');
            var selectedFromSmallWindow = $('#listingContent > div:not(#sectionProfile) > a.selected');
            if ($(selectedFromSmallWindow).length > 0) {
                $(selectedFromSmallWindow).parent('div').removeClass('displayAway');
                var hrefValue = $(selectedFromSmallWindow).attr('href');
                $('#sectionTabs a[href="' + hrefValue + '"]').parent('li').addClass('selected');
            } else {
                $('div#sectionProfile').removeClass('displayAway');
                $('#firstTab').addClass('selected');
            }
        }

        // keep track of window width
        var windowWidth = $(window).width();
        $(window).on('resize', function () {
            windowWidth = $(window).width();
            if (windowWidth <= 767)
                handleSmallWindowSize();
            else
                handleLargeWindowSize();
        });

        // Show tabs or accordion depending on window size on page load/refresh
        if (windowWidth > 767) {
            handleLargeWindowSize();
        }
        else {
            handleSmallWindowSize();
        }

        $(document).on('click', '#sectionTabs > li > a', function (evt) {
            evt.preventDefault();
            if (windowWidth > 767) {
                var currentTarget = $(this).attr('href');

                // select the correct tab section
                $('#listingContent > div').addClass('displayAway');
                $(currentTarget).removeClass('displayAway');

                // set the tabs to the correct class
                $('ul#sectionTabs li').removeClass('selected');
                $(this).parent('li').addClass('selected');
                $('#listingContent > div:not(#sectionProfile) a').removeClass('selected');
                $(currentTarget).find('a').addClass('selected');
            }
        });

        $(document).on('click', '#listingContent > div > a', function (evt) {
            evt.preventDefault();
            if (windowWidth <= 767) {
                if ($(this).hasClass('selected')) {
                    $(this).removeClass('selected');
                    $(this).siblings('.sectionContent').slideUp();
                } else {
                    $(this).addClass('selected');
                    $(this).siblings('.sectionContent').slideDown();
                }
            }
        })

        // select the correct tab by default
        if (window.location.hash) {
            var $a = $('a[href="' + window.location.hash + '"]');
            $a.trigger('click').scrollTop();
        }

        // setup anchor click handlers
        $(document).on('click', 'div.articleListing > dl > dt > a, div#summary > a', function (evt) {
            if (windowWidth > 1204) {
                evt.preventDefault();
                Shadowbox.open({
                    player: 'iframe',
                    content: $(this).attr('href'),
                    title: $(this).attr('title'),
                    width: 800,
                    height: ($(this).is('.audioVideo') ? 700 : 500) // if its a video have wider overlay
                });
            }
            else {

            }
        });

        $("div#suggestedCats h2").on('click', function (evt) {
            if (windowWidth < 975) {
                $(this).toggleClass('expanded');
                $("div#suggestedCats > ul").slideToggle("slow");
            }
        });

        // EXCLUSIVE OFFERS FUNCTIONS
        $('#specialOffer > a').on("click", function () {
            $('#offerDetails').slideToggle("slow");
            $(this).toggleClass("closeOffer");

            if ($(this).hasClass("closeOffer")) {
                $(this).find("span").text("Hide Details");
            }

            else {
                $(this).find("span").text("View Details");
            }

            return false;
        });

        // Owl Carousel
        $('.owl-one').owlCarousel({
            loop: false,
            margin: 5,
            responsiveClass: true,
            responsive: {
                0: {
                    items: 1,
                    autoWidth: true,
                    nav: false
                },
                600: {
                    items: 2,
                    autoWidth: true,
                    nav: false
                },
                800: {
                    items: 3,
                    autoWidth: false,
                    nav: true
                }
            }
        });

        // initial required scripts

        // Pre-Qualifiers functionality script
        // check if any prequalifiers are present
        var $prequalifiers = $('.logic-prequalifier');
        if ($prequalifiers.length && !$('#formError ul#errors li')[0]) {
            // hide the form while we answer prequalifiers
            $('.logic-the-big-form').hide();

            // only display one prequalifier at a time
            if ($prequalifiers.length > 1) {
                $prequalifiers.slice(1).hide();
            }
            $prequalifiers.first().show();

            $('.logic-capital-prequalifier-yes-button').on("click", function () {
                $('input[name="Capital"]').val($('#getFranchiseDetails').data('capital'));
            });
            $('.logic-timeframe-prequalifier-yes-button').on("click", function () {
                $('input[name="Timeframe"]').val($('#getFranchiseDetails').data('timeframe'));
            });

            // when yes button is clicked...
            $('.logic-prequalifiers-yes-button').on("click", function () {
                var $yesButton = $(this);

                // remove the prequalifier
                var $prequalifier = $yesButton.closest('.logic-prequalifier');

                // but select the answer in the mock select first
                if ($yesButton.hasClass('logic-actually-a-no-button')) {
                    $prequalifier.find('.logic-prequalifier-mock-input').val('No');
                }
                else {
                    $prequalifier.find('.logic-prequalifier-mock-input').val('Yes');
                }

                $prequalifier.removeClass('logic-prequalifier').hide();

                // and show the next prequalifier, or show the form if all prequalifiers are answered
                var $currentPrequalifiers = $('.logic-prequalifier');
                if ($currentPrequalifiers.length) {
                    $currentPrequalifiers.first().show();
                }
                else {
                    $('.logic-the-big-form').show();
                    $(".qualified-success").fadeIn("fast").delay("2000").fadeOut("fast");
                }

                return false;
            });

            // when no button is clicked...
            $('.logic-prequalifiers-no-button').on("click", function () {

                // show the "sorry" negative answer div
                var $noButton = $(this);
                var $sorryDiv = $noButton.closest('.logic-prequalifier').children('.logic-result-for-negative-answer');
                var $question = $noButton.closest('.logic-question');
                $question.hide();
                $sorryDiv.show();
                $('.owl-one').owlCarousel('refresh');
                return false;
            });
        }
        else {
            $('.logic-the-big-form').show();
        }

        var $stateId = $("select[name='StateId']");
        var getStatesUrl = $stateId.data("url");

        // accepted countries pre-qualifiers
        $("#logic-selected-country-code").select2({ width: "200px" });
        
        if (window.franchiseEnquiryFormSettings.mustBeBasedInAcceptedCountry || window.franchiseEnquiryFormSettings.mustBeBasedInAcceptedRegion) {
            setTimeout(function () {
                if ($('.logic-remembered-address').hasClass('logic-remembered-indeed')) {
                    $('.logic-remembered-address').hide();
                    $('.flag-wrapper').show();
                    $('.logic-address-search-field').show();
                }
            }, 100);
        }

        $("#logic-show-country-options").on("click", function (e) {
            $("#logic-country-options-prompt").hide();
            $("#logic-country-options").fadeIn("fast");
        });

        $("#logic-selected-country-code").on("select2:select", function (e) {
            
            var selectedCountry = e.params.data;
            if (window.franchiseEnquiryFormSettings.mustBeBasedInAcceptedCountry) {
                $("#" + selectedCountry.id + "-flag").trigger("click");
            }

            if (selectedCountry.id) {
                selectedCountryCode = selectedCountry.id;
                selectedCountryFullName = selectedCountry.text;

                getStates(selectedCountryCode, function (stateOptions) {
                    if (window.franchiseEnquiryFormSettings.acceptedRegions.length) {
                        updateAcceptedRegions(stateOptions);
                    }

                    if (window.franchiseEnquiryFormSettings.mustBeBasedInAcceptedCountry) {
                        $('input[name="CountryCode"]').val(selectedCountryCode);

                        // Clean up and expand address, since we're changing the country
                        $('.logic-address-search-field input').val('');
                        $('.add-address-field').hide();
                        $('.logic-manual-address').show();
                        $("input[name='Address1']").val("");
                        $("input[name='Address2']").val("");
                        $("input[name='City']").val("");
                        $("input[name='Postcode']").val("");
                        $("input[name='Telephone']").val("");
                        $stateId.val("");
                        // Remove old regions, add new ones
                        $stateId.find("option[value!='']").remove();

                        if (stateOptions.length)
                            $stateId.append(stateOptions);
                    }
                });

                if (window.franchiseEnquiryFormSettings.acceptedCountries.indexOf(selectedCountry.id) >= 0) {
                    countryCanBeAccepted = true;
                    $("#logic-submit-country-not-accepted").hide();
                    $("#logic-submit-country-accepted").show();
                } else {
                    countryCanBeAccepted = false;
                    $("#logic-submit-country-not-accepted").show();
                    $("#logic-submit-country-accepted").hide();
                }
            } else {
                selectedCountryCode = null;
                selectedCountryFullName = null;
                $("#logic-submit-country-not-accepted").hide();
                $("#logic-submit-country-accepted").hide();
            }
        });

        $(".logic-submit-country").on("click", function (e) {
            if (countryCanBeAccepted) {
                $('input[name="LookingForFranchiseInCountryCode"]').val(selectedCountryCode);
            }
            else {
                var text1 = $('#logic-PrequalifierCountryConfirmationNeeded-this-country-either').text();
                $('#logic-PrequalifierCountryConfirmationNeeded-this-country-either').text(text1.replace('this country either', selectedCountryFullName));

                $(".franchiseWrongCountryAlert-1").hide();
                $(".franchiseWrongCountryAlert-2").fadeIn("fast");
            }

            return false;
        });

        getStates = function (countryCode, callback) {
            var url = getStatesUrl.replace("xx", countryCode);
            $.get(url, function (data) {
                var html = "";

                // add state options returned from AJAX
                $(data).each(function () {
                    html += '<option value="' + this.stateId + '">' + this.stateName + '</option>';
                });

                // call callback passing in state options
                callback($.parseHTML(html));
            });
        };

        updateAcceptedRegions = function (stateOptions) {
            var $acceptedRegionOptions = $(stateOptions).filter(function () { return window.franchiseEnquiryFormSettings.acceptedRegions.indexOf(selectedCountryCode + "." + $(this).text()) >= 0 });
            
            $('.logic-accepted-regions-select').empty();
            
            if ($acceptedRegionOptions.length > 1) {
                var $notSelectedOption = $('<option value="NotSelected">' + window.franchiseEnquiryFormSettings.labels.select + '</option>');
                $('.logic-accepted-regions-select').append($notSelectedOption);
                $('.logic-accepted-regions-select').append($acceptedRegionOptions.clone());
                var $noneOfTheAboveOption = $('<option value="NoneOfTheAbove">' + window.franchiseEnquiryFormSettings.labels.noneOfTheAbove + '</option>');
                $('.logic-accepted-regions-select').append($noneOfTheAboveOption);

                $('.logic-accepted-regions-select-exactly-one').hide();
                $('.multi-loc').show();
                $('.logic-accepted-regions-select-more-than-one').show();
                $('.logic-prequalifiers-region-submit-button').show();
                $('.logic-prequalifiers-region-yes-button').hide();
                $('.logic-prequalifiers-region-no-button').hide();
            } else if ($acceptedRegionOptions.length == 1) {
                $('.logic-accepted-regions-select').append($acceptedRegionOptions.clone());
                $('.logic-accepted-regions-select-exactly-one').show();
                $('.multi-loc').hide();
                $('.logic-accepted-regions-select-exactly-one').text($('.logic-accepted-regions-select-more-than-one').text() + ' ' + $acceptedRegionOptions[0].text);
                $('.logic-accepted-regions-select-more-than-one').hide();
                $('.logic-prequalifiers-region-submit-button').hide();
                $('.logic-prequalifiers-region-yes-button').show();
                $('.logic-prequalifiers-region-no-button').show();
            }
        };

        // Change flag to selected country and change input to country postcode format
        $(".flag-dropdown li").on("click", function (e) {

            let option = $(e.target).closest("li");
            let countryCode = $(option).data("country-code");
            let countryName = $(option).data("country-name");

            $("input[name='CountryCode']").val(countryCode);
            $(".flag-dropdown-wrap").hide();
            $(".selected-flag").removeClass("active-flag");
            $(".selected-flag-img").attr("src", $(option).find("img").attr("src"));

            // try and set dialling code
            $("select[name='DiallingCode'] option[value='" + $(option).data("dialling-code") + "']:contains('" + countryName + "')").prop("selected", true);
            $("select[name='DiallingCode']").trigger("change");

            // update states
            getStates(countryCode, function (stateOptions) {
                $stateId.find("option[value!='']").remove();

                if (stateOptions && stateOptions.length) {
                    $stateId.append(stateOptions);
                    $(".logic-region").show();
                } else {
                    validator.element($stateId);
                    $(".logic-region").hide();
                }
                setFields({ StateId: "", StateName: "" });
            });

            var normalisedCountryCode = countryCode.toLowerCase();
            if (normalisedCountryCode == "uk")
                normalisedCountryCode = "gb";
            autocomplete.setComponentRestrictions({ "country": [normalisedCountryCode] });
        });

        // Google places lookup
        var autocompleteInput = document.getElementById("place-search");

        var observerHack = new MutationObserver(function () {
            observerHack.disconnect();
            $("#place-search").attr("autocomplete", "new-password");
        });
        observerHack.observe(autocompleteInput, {
            attributes: true,
            attributeFilter: ['autocomplete']
        });

        var countryCode = $("input[name='CountryCode'").val();
        var autocompleteOptions = {};
        var autocomplete = new google.maps.places.Autocomplete(autocompleteInput, autocompleteOptions);
        autocomplete.setFields(["address_component"]);
        autocomplete.addListener("place_changed", fillInAddress);
        var normalisedCountryCode = countryCode.toLowerCase();
        if (normalisedCountryCode == "uk")
            normalisedCountryCode = "gb";
        autocomplete.setComponentRestrictions({ "country": [normalisedCountryCode] });

        function fillInAddress() {
            var autocompletedPlace = autocomplete.getPlace();

            var entityName = "";
            var postbox = "";
            var subpremise = "";
            var floor = "";
            var addressLineWithStreetNumber = "";
            var streetNumber = "";
            var addressLinePriority1 = "";
            var addressLinePriority2 = "";
            var city = "";
            var postcode = "";
            var stateId = "";
            var stateName = "";

            if (autocompletedPlace.address_components == null) {
                autocompletedPlace.address_components = [];
            }

            if (autocompletedPlace.name != null && autocompletedPlace.name != "" && autocompletedPlace.types != null && autocompletedPlace.types.length != null) {
                autocompletedPlace.address_components.push({ long_name: autocompletedPlace.name, short_name: autocompletedPlace.name, types: autocompletedPlace.types });
            }

            for (var ac = 0; ac < autocompletedPlace.address_components.length; ac++) {
                var addressComponent = autocompletedPlace.address_components[ac];
                for (var t = 0; t < addressComponent.types.length; t++) {

                    if (addressComponent.types[t] == "point_of_interest") {
                        entityName = addressComponent.long_name;
                    }
                    if (addressComponent.types[t] == "establishment") {
                        entityName = addressComponent.long_name;
                    }

                    if (addressComponent.types[t] == "post_box") {
                        postbox = addressComponent.long_name;
                    }
                    if (addressComponent.types[t] == "subpremise") {
                        subpremise = addressComponent.long_name;
                    }
                    if (addressComponent.types[t] == "floor") {
                        floor = addressComponent.long_name;
                    }

                    if (addressComponent.types[t] == "street_number") {
                        streetNumber = addressComponent.long_name;
                    }
                    if (addressComponent.types[t] == "street_address") {
                        addressLineWithStreetNumber = addressComponent.long_name;
                    }

                    if (addressComponent.types[t] == "route") {
                        addressLinePriority1 = addressComponent.long_name;
                    }

                    if (addressComponent.types[t] == "sublocality") {
                        addressLinePriority2 = addressComponent.long_name;
                    }
                    if (addressComponent.types[t] == "sublocality_level_1") {
                        addressLinePriority2 = addressComponent.long_name;
                    }
                    if (addressComponent.types[t] == "neighborhood") {
                        if (addressLinePriority2 == '') {
                            addressLinePriority2 = addressComponent.long_name;
                        }
                    }

                    if (addressComponent.types[t] == "locality") {
                        city = addressComponent.long_name;
                    }
                    if (addressComponent.types[t] == "postal_town") {
                        if (city != '' && city != addressComponent.long_name && addressLinePriority2 == '') {
                            addressLinePriority2 = city;
                        }
                        city = addressComponent.long_name;
                    }

                    if (addressComponent.types[t] == "postal_code") {
                        postcode = addressComponent.long_name;
                    }

                    if (addressComponent.types[t].startsWith("administrative_area") || addressComponent.types[t] == "postal_town" || addressComponent.types[t] == "political") {
                        $("select[name='StateId']").find("option").each(function () {
                            if ($(this).text().toLowerCase() == addressComponent.long_name.toLowerCase()) {
                                stateId = $(this).val();
                                stateName = $(this).text();
                            }
                        });
                    }
                }
            }

            var address1 = "";
            if (addressLineWithStreetNumber != "") {
                address1 = addressLineWithStreetNumber;
            }
            else if (addressLinePriority1 != "") {
                address1 = (streetNumber !== "" ? streetNumber + " " : "") + addressLinePriority1;
            }
            if (floor !== "") {
                address1 = floor + ", " + address1;
            }
            if (subpremise !== "") {
                address1 = subpremise + ", " + address1;
            }
            if (postbox !== "") {
                address1 = postbox + ", " + address1;
            }

            var address2 = addressLinePriority2;
            if (entityName != "") {
                address2 = address1;
                address1 = entityName;
            }

            $("#place-search").val("");
            setFields({ Address1: address1, Address2: address2, City: city, Postcode: postcode, StateId: stateId, StateName: stateName });
            validateAddress();
        }

        if ($('input[name="Address1"]').val() &&
            $('input[name="City"]').val() &&
            $('input[name="Postcode"]').val() &&
            $('select[name="StateId"]').val()) {
            $('.logic-remembered-address .Address1').text($('input[name="Address1"]').val());
            $('.logic-remembered-address .Address2').text($('input[name="Address2"]').val());
            $('.logic-remembered-address .City').text($('input[name="City"]').val());
            $('.logic-remembered-address .Postcode').text($('input[name="Postcode"]').val());
            $('.logic-remembered-address .StateName').text($('select[name="StateId"] option:selected').text());

            $('.logic-remembered-address').addClass('logic-remembered-indeed');
            $('.logic-remembered-address').show();
            $('.flag-wrapper').hide();
            $('.logic-address-search-field').hide();
            //$('.logic-address-search-field input').val('');
            $('.logic-manual-address').hide();
            $('.add-address-field').hide();
        }
        else if ($('input[name="Address1"]').val() ||
            $('input[name="Address2"]').val() ||
            $('input[name="City"]').val() ||
            $('input[name="Postcode"]').val()) {
            //$('.logic-address-search-field').hide();
            $('.logic-address-search-field input').val('');
            $('.logic-manual-address').show();
            $('.add-address-field').hide();
        }

        $('.logic-unhide-manual-address').on('change keyup blur input', function () {
            //$('.logic-address-search-field').hide();
            $('.logic-address-search-field input').val('');
            $('.add-address-field').hide();
            $('.logic-manual-address').show();
        });

        // Dialling code
        $("select[name='DiallingCode']").on("change", function () {
            $(".dial-code-placeholder").text($(this).val());
        });

        function validateAddress() {
            // validate address fields
            $(".logic-manual-address :input").each(function () {
                validator.element(this);
                var $this = $(this);
                $this.addClass("highlight-bg");
                setTimeout(function () { $this.removeClass('highlight-bg'); }, 600);
            });

            if ($(".logic-manual-address :input").valid()) {
                $(".logic-prefilled-address").fadeIn("fast");
                $(".add-address-field").fadeOut("fast");
                $(".logic-manual-address").fadeOut("fast");
            } else {
                $(".logic-manual-address").fadeIn("fast");
                $('.logic-prefilled-address').fadeOut("fast");
                $(".logic-add-address").fadeOut("fast");
            }
        }

        $(".logic-change-address").on("click", function () {
            $(".logic-prefilled-address").hide();
            $(".logic-manual-address").show();
        });
        $('.logic-change-remembered-address').on("click", function () {
            $('.logic-remembered-address').hide();
            $(".add-address-field").fadeIn("fast");
            $('.flag-wrapper').fadeIn('fast');
            $('.logic-address-search-field').fadeIn('fast');
            $('input[name="Address1"]').val('');
            $('input[name="Address2"]').val('');
            $('input[name="City"]').val('');
            $('input[name="Postcode"]').val('');
        });
        $(".logic-add-address").on("click", function () {
            $(".logic-manual-address").fadeIn("fast");
            $(".flag-wrapper").fadeIn("fast");
            $(".logic-address-search-field").fadeIn("fast");
            $(".logic-prefilled-address").fadeOut("fast");
            $(".logic-remembered-address").fadeOut("fast");
            $(".add-address-field").fadeOut("fast");
            $(".postcode-candidates").fadeOut("fast");
        });

        // Flag dropdown
        $(".selected-flag").on("click", function () {
            $(this).parents(".flag-wrapper").find(".flag-dropdown-wrap").slideToggle("fast");
            $(".flag-dropdown-filter").trigger("focus");
            $(this).toggleClass("active-flag");
        });

        // filter textbox
        $(".flag-dropdown-filter").on("change keyup blur input", function (e) {
            var filterText = $(this).val().toLowerCase();
            $(".flag-dropdown li").each(function () {
                var $li = $(this);
                if (!filterText) {
                    $li.show();
                }
                else {
                    var show = false;
                    if ($li.get(0).id.toLowerCase().indexOf(filterText) > -1) {
                        show = true;
                    }
                    else if ($li.find(".country-name").text().toLowerCase().replace(/\u00a0/g, " ").indexOf(filterText) > -1) {
                        show = true;
                    }

                    if (show) {
                        $li.show();
                    }
                    else {
                        $li.hide();
                    }
                }
            });
        });

        // close dropdowns when clicked elsewhere on the page
        $(document).on("touchstart click", function (event) {
            if (!$(event.target).parents().is(".flag-wrapper")) {
                $(".flag-wrapper").find(".flag-dropdown-wrap").hide();
                $(".selected-flag").removeClass("active-flag");
            }
            if (!$(event.target).parents().is(".address-wrapper")) {
                $(".address-wrapper").find(".address-dropdown").hide();
            }
            if (!$(event.target).parents().is(".address-wrapper-notUK")) {
                $(".address-wrapper-notUK").find(".address-dropdown-notUK").hide();
            }
        });

        // Extra optional questions toggle
        $(".added-opts-toggle").on("click", function () {
            $(this).find(".fa").toggleClass("icon-rotate");
            $(this).next().slideToggle("fast");
        });

        // Dynamically resize the telephone code select and add corresponding padding to its parent
        $("select[name='Email']").on("change", function () {
            var selectedDialCode = $(this).val();
            $(".dial-code-placeholder").text(selectedDialCode);

            if (selectedDialCode.length == 1) {
                $(".tel-wrapper").addClass("code-1");
            }
            else if (selectedDialCode.length == 2) {
                $(".tel-wrapper").addClass("code-2");
            }
            else if (selectedDialCode.length == 3) {
                $(".tel-wrapper").addClass("code-3");
            }
            else if (selectedDialCode.length == 4) {
                $(".tel-wrapper").addClass("code-4");
            }
        });

        var $form = $("#enquiryForm");

        // on submit script
        // lowercase email address for devices on submit
        setTimeout(function () {
            $form.on("submit", function () {

                $form.validate();
                if ($form.valid()) {
                    $("input[name='Email']").val(function (i, v) { return v.toLowerCase(); });
                    $("input[name='EmailConfirm']").val(function (i, v) { return v.toLowerCase(); });
                    $("button[type='Submit']").prop("disabled", "disabled").text(window.franchiseEnquiryFormSettings.labels.sending);
                    $("#formError").hide();
                }
                else {
                    $('ul#errors').empty();

                    var errorTexts1 = [];
                    var errorTexts2 = [];
                    $('label.error:visible').each(function () {
                        var field = $(this).closest('li').find('label').first();
                        var fieldName = field.text();
                        //errorTexts.push(fieldName + ' - ' + $(this).text());
                        if (field.hasClass('logic-top-field')) {
                            errorTexts1.push(fieldName.replace('*', ''));
                        }
                        else {
                            errorTexts2.push(fieldName.replace('*', ''));
                        }
                    });
                    for (var ei in errorTexts1) {
                        $('ul#errors').append($('<li>' + errorTexts1[ei] + '</li>'));
                    }

                    if ($('input[name="Address1"]').val() ||
                        $('input[name="Address2"]').val() ||
                        $('input[name="City"]').val() ||
                        $('input[name="Postcode"]').val()) {

                        if ($('input[name="Address1"]').hasClass('error') ||
                            $('input[name="Address2"]').hasClass('error') ||
                            $('input[name="City"]').hasClass('error') ||
                            $('input[name="Postcode"]').hasClass('error') ||
                            $('input[name="StateId"]').hasClass('error')) {
                            $('.logic-remembered-address').hide();
                            //$('.logic-address-search-field').hide();
                            $('.logic-address-search-field input').val('');
                            $('.logic-prefilled-address').hide();
                            $('.add-address-field').hide();
                            $('.logic-manual-address').show();
                        }
                        else {
                            $('#addressSearchField').removeClass('error');
                            $('#autocompleteInput').removeClass('error');
                        }
                    }
                    else {
                        if (!$('.logic-manual-address').is(':visible')) {
                            $('#addressSearchField').addClass('error');
                            $('#autocompleteInput').addClass('error');
                            if ($('#addressSearchField').is(':visible') && $('#addressSearchField').hasClass('error')) {
                                $('ul#errors').append($('<li>Find Address</li>'));
                            }
                            if ($('#autocompleteInput').is(':visible') && $('#autocompleteInput').hasClass('error')) {
                                $('ul#errors').append($('<li>Search for your address</li>'));
                            }
                        }
                    }

                    $('.logic-remembered-address').hide();
                    //$('.logic-address-search-field').hide();
                    $('.logic-address-search-field input').val('');
                    $('.logic-prefilled-address').hide();
                    $('.add-address-field').hide();
                    $('.logic-manual-address').show();

                    for (var ei in errorTexts2) {
                        $('ul#errors').append($('<li>' + errorTexts2[ei] + '</li>'));
                    }

                    $(window).scrollTop(0);
                    $('#formError').show();

                }
            });
        }, 100);

        // region options pre-qualifier

        $('.logic-prequalifiers-region-submit-button').on("click", function () {
            var isNotSelectedSelected = $('.logic-accepted-regions-select').val() == "NotSelected";
            if (isNotSelectedSelected) {
                $('.logic-multi-loc-error').show();
                $('.select-placeholder').addClass('error-select');
                return false;
            }
            var isNoneOfTheAboveRegionSelected = $('.logic-accepted-regions-select').val() == "NoneOfTheAbove";
            if (isNoneOfTheAboveRegionSelected) {
                $('.logic-prequalifiers-region-no-button').trigger("click");
            }
            else {
                $('.logic-prequalifiers-region-yes-button').trigger("click");
            }
            return false;
        });
        $('.logic-accepted-regions-select').on("change", function () {
            var $selectedRegion = $(".logic-accepted-regions-select option:selected").text();
            $('.select-placeholder-text').text($selectedRegion);
            if ($('.multi-loc-error').css('display') == "inline-block") {
                $('.multi-loc-error').hide();
                $('.select-placeholder').removeClass('error-select');
            }
        });
        $('.logic-prequalifiers-region-yes-button').on("click", function () {
            if (window.franchiseEnquiryFormSettings.mustBeBasedInAcceptedRegion) {
                $('input[name="LookingForFranchiseInStateId"]').val($('.logic-accepted-regions-select').first().val());
            }
            else {
                $('input[name="LookingForFranchiseInStateId"]').val($('.logic-accepted-regions-select').first().val());
            }
            return false;
        });
        $('.logic-prequalifiers-region-no-button').on("click", function () {
            // show the "sorry" negative answer div
            var $noButton = $(this);
            var $sorryDiv = $noButton.closest('.logic-prequalifier').children('.logic-result-for-negative-answer');
            var $question = $noButton.closest('.logic-question');
            $question.hide();
            $sorryDiv.show();
            $('.owl-one').owlCarousel('refresh');
            return false;
        });

        // Showing and hiding SMS checkbox depending on the selected dial code
        let showOrHideSmsLabel = function () {
            let selectedDiallingCode = $("select[name='DiallingCode']").val();
            if (phoneNumberCheckService.canSubscribeToSmsDialCodes.indexOf('+' + selectedDiallingCode) < 0) {
                $('.logic-sms-label').hide();
                $('.logic-sms-label input').prop('disabled', 'disabled');
            } else {
                $('.logic-sms-label').show();
                $('.logic-sms-label input').prop('disabled', null);
            }
        }
        $("select[name='DiallingCode']").on("change", showOrHideSmsLabel);
        showOrHideSmsLabel();

        let validateTelephone = function () {
            $("input[name='Telephone']").valid();
        };
        let setTelephoneLabel = function () {
            if ($('.logic-wants-sms-notifications') && $('.logic-wants-sms-notifications').is(':visible') && $('.logic-wants-sms-notifications').is(':checked')) {
                $('.logic-telephone-label').text('Mobile phone number');
            }
            else {
                $('.logic-telephone-label').text('Phone number');
            }
        }

        $('.logic-wants-sms-notifications').on('change', function () {
            setTelephoneLabel();
            validateTelephone();
        });


        setTelephoneLabel();
        if ($("input[name='Telephone'").val()) {
            validateTelephone();
        }


        // Textareas dynamical resizing
        $(function () {
            $.each($('textarea.resize-this'), function () {
                var offset = this.offsetHeight - this.clientHeight;
                var resizeTextarea = function (el) {
                    $(el).css('height', 'auto').css('height', el.scrollHeight + offset);
                };
                $(this).on('keyup input', function () { resizeTextarea(this); }).removeClass('resize-this');
            });
        });

        // Validation
        var validator = $("#enquiryForm").validate({
            ignore: [],
            submitHandler: function (form) {
                form.submit();
            },
            onkeyup: function (element) {
                if ($(element).hasClass('logic-validate-onkeyup')) {
                    $(element).valid();
                }
            },
            onfocusout: function (element) { $(element).valid(); }
        });

    });

})(jQuery);